import { gql } from "lib/apolloClient";

export const projectDeadlineFragment = {
  projectDeadlineDetails: gql`
    fragment projectDeadlineItem on ProjectDeadline {
      id
      deadline {
        id
        deadlineDate
        title
        description
        isDeadlineAllDay
      }
      project {
        id
        projectGroup {
          id
          name
          subType
          type
          courses {
            edges {
              node {
                id
                title
                learningCourse {
                  id
                  title
                  academicCourse {
                    id
                    label
                  }
                }
              }
            }
          }
          subject {
            id
            name
            type
            ibOfferedSubject {
              id
              contentSubject {
                id
                assessmentYearTitle
              }
            }
          }
        }
        fields(filters: { uids: ["title", "topic"] }) {
          id
          uid
          value
        }
        status
        conversation {
          id
          unreadMessageCount
        }
      }
    }
  `,

  studentCountItem: gql`
    fragment studentCountItem on Student {
      id
      tasks(
        filters: {
          academicYearId: $academicYearId
          courseIds: $courseIds
          entityTypes: $entityTypes
          excludedAssessmentTypes: $excludedAssessmentTypes
          startDate: $startDate
          endDate: $endDate
          projectGroupIds: $projectGroupIds
          searchText: $searchText
          overDueStartDate: $overDueStartDate
          overDueEndDate: $overDueEndDate
          curriculumProgramIds: $curriculumProgramIds
        }
      ) {
        statusWiseCount {
          category
          count
          __typename
        }
        __typename
      }
      __typename
    }
  `,

  parentCountItem: gql`
    fragment parentCountItem on FamilyMember {
      id
      tasks(
        filters: {
          academicYearId: $academicYearId
          courseIds: $courseIds
          entityTypes: $entityTypes
          excludedAssessmentTypes: $excludedAssessmentTypes
          startDate: $startDate
          endDate: $endDate
          projectGroupIds: $projectGroupIds
          searchText: $searchText
          overDueStartDate: $overDueStartDate
          overDueEndDate: $overDueEndDate
          curriculumProgramIds: $curriculumProgramIds
        }
        studentIds: $studentIds
      ) {
        statusWiseCount {
          category
          count
          __typename
        }
        __typename
      }
      __typename
    }
  `,
};

export const projectGroupTaskFragment = {
  projectGroupTaskBasicFragment: gql`
    fragment projectGroupTaskItem on ProjectGroupTask {
      id
      title
      description
      dueOn
      closesOn
      isStudentSubmissionEnabled
      submission {
        id
        type
      }
    }
  `,
};
